import { getInviteById } from 'api/invites.api';
import { $form } from 'signals/global.signals';
import displayError from 'utils/displayError';

const fetchAndSetInviteData = async (token) => {
  try {
    const inviteData = await getInviteById(token);
    $form.update({
      email: inviteData.email,
      id: inviteData.id,
    });
  } catch (error) {
    displayError({
      message: 'Failed to load invitation data. Please check your invite link.',
      title: 'Invitation Error',
    });
  }
};

export default fetchAndSetInviteData;
